import React from 'react';
import { Box, Flex, Input } from '@chakra-ui/react';
import { useTranslations } from 'contexts/LocalizationContext';

import RestaurantMultiSelect from '../../../../common/components/RestaurantSelect/RestaurantMultiSelect';
import { RestaurantInfo } from '../../../../contexts/SessionContext/SessionContext';
import { useHistoryFilterContext } from '../../context/HistoryFilterContext/hooks/useHistoryFilterContext';
import DateRangeSelect from '../DateRangeSelect/DateRangeSelect';
import HistoryActionSelect from '../HistoryActionSelect/HistoryActionSelect';

type HistoryFiltersProps = {
  userRestaurants: RestaurantInfo[];
  isTwoFactorReturnEnabled: boolean;
  isDepositEnabled: boolean;
};

const HistoryFilters = ({ userRestaurants, isTwoFactorReturnEnabled, isDepositEnabled }: HistoryFiltersProps) => {
  const translations = useTranslations();
  const {
    historyState,
    orderIdInput,
    handleSelectRestaurants,
    handleSelectHistoryAction,
    handleSelectDatesRange,
    handleOrderIdChange,
  } = useHistoryFilterContext();

  return (
    <>
      <Flex pt={2} mr={2} width={'100%'}>
        <Input
          width={['100%', '100%', '50%']}
          borderColor={'beige.50'}
          placeholder={translations('history_filter_order_id_placeholder')}
          value={orderIdInput}
          onChange={handleOrderIdChange}
        />
      </Flex>
      <Box pt={2} mr={2} minWidth={'300px'}>
        <RestaurantMultiSelect
          selectedRestaurantIds={historyState.restaurantIds}
          userRestaurants={userRestaurants}
          onSelectRestaurants={handleSelectRestaurants}
          isDisabled={userRestaurants.length === 1}
        />
      </Box>
      <Box pt={2} mr={2} minWidth={'300px'}>
        <HistoryActionSelect
          isTwoFactorReturnEnabled={isTwoFactorReturnEnabled}
          isDepositEnabled={isDepositEnabled}
          onHistoryActionChange={handleSelectHistoryAction}
          action={historyState.action}
        />
      </Box>
      <Box pt={2} mr={2} minWidth={'300px'}>
        <DateRangeSelect
          startDate={historyState.startDate}
          endDate={historyState.endDate}
          dateRange={historyState.dateRange}
          onDatesRangeChange={handleSelectDatesRange}
        />
      </Box>
    </>
  );
};

export default HistoryFilters;
